import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/CloseModal.svg'


const _hoisted_1 = { class: "pickedUpReservation" }
const _hoisted_2 = { class: "pickedUpReservation__header" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "pickedUpReservation__buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.showModalDelete)
    ? (_openBlock(), _createBlock(_component_Modal, {
        key: 0,
        onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('closeModal')))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('pickedUpRevervation')), 1),
              _createElementVNode("img", {
                src: _imports_0,
                alt: "CloseModal",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeModal')))
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Button, {
                variant: "filled",
                title: _ctx.$t('yes'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('pickedUpdeletedOrRemovedRequest', _ctx.idDelivery)))
              }, null, 8, ["title"]),
              _createVNode(_component_Button, {
                variant: "notBordered",
                title: _ctx.$t('no'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('closeModal')))
              }, null, 8, ["title"])
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}